import { logError } from '@office-start/telemetry-service';
export function getWindowsProcessStartTime() {
    if (window.Windows) {
        // This window object is also used when we log boot perf markers,
        // will likely already be set by office-pwa.ts before this.
        if (window.windowsProcessStartTime) {
            return window.windowsProcessStartTime;
        }
        else {
            try {
                window.windowsProcessStartTime =
                    window.Windows.System.Diagnostics.ProcessDiagnosticInfo.getForCurrentProcess().processStartTime.getTime();
                return window.windowsProcessStartTime;
            }
            catch (error) {
                logError({
                    eventName: 'getWindowsProcessStartTime',
                    errorType: 'Process_Start_Time_Missing_Error',
                    message: error === null || error === void 0 ? void 0 : error.message,
                });
                return undefined;
            }
        }
    }
    else {
        // Not running in Windows environment.
        return undefined;
    }
}
//# sourceMappingURL=getWindowsProcessStartTime.js.map